// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__3ABgg","small":"style_small__1p3Vz","active":"style_active__220aB","clickable":"style_clickable__3_IrU"};